<template>
  <div class="fc-button">
    <img class="mobile-arrow" src="@/assets/mobile-nav-arrow.svg" />
    <span>{{this.text}}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style lang="scss" scoped>
.fc-button {
  cursor: pointer;
  position: relative;
  background: rgba(255, 255, 255, 0.25);
  border-bottom: 1px solid #fff;
  display: block;
  height: auto;
  text-align: left;
  padding: 5px 15px;

  span {
    display: block;
    text-align: left;
    padding: 5px 15px;
    white-space: nowrap;

    font-size: 24px;
    color: #ffffff;
    letter-spacing: 0;

    text-transform: uppercase;
  }
  .mobile-arrow {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%) scaleX(-1);
  }
}
</style>